function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

export { getHTMLElementScroll as g };
//# sourceMappingURL=getHTMLElementScroll-RRV0AW8Y.js.map
